import { render, staticRenderFns } from "./checkbox-input.vue?vue&type=template&id=c954c98a&"
import script from "./checkbox-input.vue?vue&type=script&lang=js&"
export * from "./checkbox-input.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports